import { render, staticRenderFns } from "./setup_app.vue?vue&type=template&id=610260fc"
import script from "./setup_app.vue?vue&type=script&lang=js"
export * from "./setup_app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports